import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import type {
  MessengerAuthProvider,
  MessengerAuthStartResponse,
  MessengerAuthStatusResponse,
  MessengerAuthCompleteResponse,
  MessengerAuthError,
} from './dto'
import {
  ChartDataPoint,
  FeedChartDataPoint,
  PriceChartDataPoint,
  MetricsChartType,
  FavoriteList,
  Mall,
  MetricsComparison,
  ProductInfo,
  User,
  ContentChartDataPoint,
  ContentStats,
  Feed,
  FeedTypes,
  Country,
  ProductReview,
  ProductReviewFilter,
  ReviewsByStar,
  ReviewsByCountry,
  TimelineEvent,
  BrandGroup,
  ExportList,
  Subscription,
  ProductOffers,
  AutocompleteSuggestion,
  CategoryTree,
  ProductListFilter,
  ProductListItem,
  ProductSalesCountry,
  Category,
  FilterPreset,
  FilterPresetType,
  FilterPresetInfo,
  ISO8601DateTimeString,
  ProductDescriptionVersion,
  StartExportResponse,
  QueryMonitoringExportFilter,
  BusinessUserStore,
  BusinessSalesStats,
  BusinessSalesProductList,
  BusinessSalesBrand,
  BusinessReviewsStopword,
  BusinessReviewsRule,
  BusinessProductNoStats,
  BusinessReviewsStopwordFilter,
  BusinessReviewsRuleFilter,
  BusinessReviewTagFilter,
  BusinessReviewTagsList,
  BusinessReviewCustomTag,
  BusinessReviewsLogRequest,
  BusinessReviewsLogListResponse,
  BusinessReviewsRuleGenerateTextRequest,
  BusinessReviewsRuleGenerateTextResponse,
  BusinessReviewsReplyPreviewRequest,
  BusinessReviewsReplyPreviewResponse,
  BusinessReviewsAISettings,
  BusinessReviewsReplyActionRequest,
  BusinessReviewsReplyRegenerateRequest,
  BusinessReviewsReplyRegenerateResponse,
  NewUser,
  FormValidationErrors,
  PromoCode,
  CategoryListFilter,
  CategoryStatBrand,
  CategoryStatMerchant,
  CategoryStat,
  CategoryPriceRange,
  CategoryPriceSegmentEntity,
  CategoryPriceSegmentFilter,
  CategoryPriceSegmentItem,
  ListingDTO,
  CategoryStatCharts,
  CategoryList,
  CategoryStatChartsQuery,
  SubjectListFilter,
  SubjectStat,
  SubjectList,
  SubjectStatChartsQuery,
  SubjectStatCharts,
  BusinessSalesProductListFilter,
  OfferChartType,
  PrimeCostResponse,
  KeywordListFilter,
  Keyword,
  KeywordBrand,
  KeywordMerchant,
  AiFeatureName,
  FeedType,
  ReverseFeedTypes,
  QuantileResponse,
  QuantileRequest,
  SellersWorkScheme,
  SubscriptionTariffs,
  SubscriptionRequest,
  SubscriptionResponse,
  CustomOffer,
  CustomOfferPaymentResponse,
  RegisterResponse,
  RegisterSendAuthCodeResponse,
  LoginData,
  LoginResponse,
  LoginSubmitAuthCodeResponse,
  RecoverySendAuthCodeResponse,
  RecoveryResetPasswordResponse,
  CompanyContactRequest,
  BLArticleList,
  BLArticle,
  PersonContactRequest,
  WarehouseChartType,
  BidderCampaignInfo,
  BidderCampaignListFilter,
  BidderCampaignStatExportFilter,
  BidderCampaignKeywordsExportFilter,
  BidderCampaignListItem,
  BidderCampaignStat,
  BidderCampaignSimplifiedBidderStat,
  BidderCampaignBidDistribution,
  VariantChartType,
  ProductListItemsSummary,
  BidderCampaignUpdateInfo,
  BidderCampaignKeywords,
  BidderCampaignKeywordsUpdate,
  BidderCampaignBidDistributionRequest,
  BusinessRegion,
  BidderProductCurrentPosition,
  KeywordStatValue,
  BidderCampaignProduct,
  BidderCampaignBidPrediction,
  BusinessSalesChartData,
  SupplyRecommendationReport,
  SupplyRecommendationRequest,
  SupplyRecommendationSettings,
  SupplyRecommendationAvailableSettings,
  ProductNameVersion,
  ProductVariationAggregates,
  FeedChartPositionsRequest,
  FeedChartPositions,
  SubjectTree,
  Subject,
  MarketplaceCommission,
  TariffCoefficient,
  BidderSyncResponse,
  BidderCampaignStatSummary,
  InventoryType,
  ProductTag,
  BusinessOrdersListItem,
  BusinessOrdersListFilter,
  OrdersGeographyListRequest,
  OrdersGeographyList,
  OrdersGeographyChartRequest,
  OrdersGeographyChart,
  OrdersMovementStatRequest,
  OrdersMovementStat,
  OrdersGeographyMacroRegionsStatRequest,
  OrdersGeographyMacroRegionsStat,
  UserKeywordList,
  UserKeywordStats,
  UserKeyword,
  ExternalAdvertisingPublication,
  ExternalAdvertisingPublicationListFilter,
  ExternalAdvertisingSearch,
  ExternalAdvertisingSearchListFilter,
  ExternalAdvertisingPublicationCount,
  SupplyBookingOrder,
  SupplyBookingOrderPlanRequest,
  BidderCampaignBudgetReplenishmentLog,
  BidderCampaignBudgetReplenishment,
  BidderCampaignStatAggregate,
  BidderCampaignStatAggregateFilter,
  BidderCampaignStatAggregateSummary,
  BidderCampaignBudgetReplenishmentUpdate,
  BusinessSalesProductChartData,
  BusinessSalesProductChartRequest,
  RepricerAddRequest,
  RepricerUpdateRequest,
  RepricerListItem,
  RepricerListFilter,
  RepricerChartsRequest,
  RepricerChangelogRequest,
  RepricerChartData,
  RepricerChangelog,
  RepricerMarginalityCalculateRequest,
  RepricerMarginalityFormula,
  RepricerMarginalityPreviewItem,
  RepricerProductInfo,
  RepricerProductAnalogue,
  RepricerGetProductsInfoRequest,
  RepricerPromotionsRequest,
  RepricerPromotionWithProducts,
  RepricerProductWithPromotions,
  BusinessSalesExpense,
  BusinessSalesExpenseList,
  BusinessSalesExpenseCreateForm,
  BusinessSalesExpenseFilter,
  BusinessSalesExpenseNameList,
  BusinessStockStatFilter,
  BusinessStockStatProductList,
  BusinessStockStatProductListRequest,
  BusinessStockStatScope,
  BusinessStockStatSummary,
  BusinessStockStatWarehouse,
  AvailableCharacteristic,
  CharacteristicValue,
  BidderCampaignHeatmapFilter,
  BidderCampaignHeatmap,
  WebauthnAuthenticator,
  WebauthnAuthenticatorCreate,
  WebauthnAddOptions,
  WebauthnLogInOptions,
  WebauthnLogInRequest,
  UserApiKey,
  CreatedUserApiKey,
  LinkedNotifierAccount,
  NotificationSettings,
  RepricerLimit,
  RepricerStoreSettings,
  RepricerProductKey,
  RepricerProductSelector,
  RepricerTagListFilter,
  RepricerTagListItem,
  RepricerConfigPatch,
  RepricerVariants,
  ISO8601DateString,
  WebinarBanner,
  AdditionalPacks,
  AdditionalPackName,
  AdditionalPackType,
  BusinessUnitEconomicsCalculationStorage,
  ChartHypothesesStorage,
  QueryMonitoringStorage,
  PartnerProgramContactRequest,
  ProductUpdateDescriptionRequest,
  ProductUpdateImagesRequest,
  BusinessUserApiTokenCreationList,
  BusinessDecodeApiTokenResponse,
  DocumentList,
  ShopAnalysisRequest,
  UpdatePrimeCostRequest,
  DeletePrimeCostRequest,
  PrimeCostChange,
  PrimeCostForShipmentRequest,
  PrimeCostForShipment,
  AdditionalExpensesPerOrderChange,
  AdditionalExpensesPerOrderForDate,
  MarketplaceAccountTaxScheme,
  SubjectPriceRange,
  SuggestionPositionsResponse,
  NicheListFilter,
  NicheObservationListResponse,
} from 'lib/dto'
import { ContextDTO } from 'lib/contextCreation'
import { HostType, Theme } from '../configs/theme'
import { ActionpayAction, actionpayGoalIds } from 'lib/dto'
import { MallCode } from 'configs/malls'
import {
  Changelog,
  Alert,
  Suggestion,
  StrapiListing,
  SuggestionsFilters,
  CreateSuggestionData,
  UpdateSuggestionData,
  UpdateSuggestionReactionResponse,
  UpdateSuggestionReactionData,
  SuggestionComment,
  CreateSuggestionCommentData,
  BlogArticlePage,
  Article,
} from './strapi'
import {
  SupportAttachment,
  SupportCase,
  SupportCaseDetails,
  SupportEvent,
  SupportSession,
} from 'lib/support/types'
import {
  SupportDialogsAiModelFilter,
  SupportDialogsListResponse,
  SupportDialogsHandoffFilter,
  SupportDialogsRevenueFilter,
  SupportDialogsDetailsResponse,
  SupportDialogsReviewCommentFilter,
  SupportDialogsReviewFilter,
  SupportDialogsUserRatingFilter,
} from 'lib/support/admin-dialogs-types'
import {
  SupportKnowledgeBaseEmbeddingFilter,
  SupportKnowledgeBaseDeleteResponse,
  SupportKnowledgeBaseImportResponse,
  SupportKnowledgeBaseHandoffFilter,
  SupportKnowledgeBaseListResponse,
  SupportKnowledgeBaseRecalculateDirtyResponse,
  SupportKnowledgeBaseRecalculateResponse,
  SupportKnowledgeBaseSaveRequest,
  SupportKnowledgeBaseSaveResponse,
  SupportKnowledgeBaseDetailsResponse,
  SupportKnowledgeBaseStatusFilter,
} from 'lib/support/admin-knowledge-base-types'

type Storage = {
  queryMonitoringStorage: QueryMonitoringStorage
  unitEconomics: BusinessUnitEconomicsCalculationStorage[]
  chartHypotheses: ChartHypothesesStorage
}

export class Context {
  isAuthorized: boolean
  hasAvailableAuthorization: boolean
  malls: Mall[]
  currentMall: Mall
  theme: Theme
  host: string
  user: User
  ip: string
  userAgent: string
  lang: string
  lastLoginType: string | null
  lastLoginDate: string | null
  private cookie: string | null
  private api: AxiosInstance
  private isServerSide: boolean

  constructor(ctx: ContextDTO, api?: AxiosInstance) {
    this.isAuthorized = ctx.isAuthorized
    this.hasAvailableAuthorization = ctx.hasAvailableAuthorization
    this.currentMall = ctx.currentMall
    this.malls = ctx.malls
    this.theme = ctx.theme
    this.host = ctx.host
    this.user = ctx.user as User
    this.cookie = ctx.cookie
    this.ip = ctx.ip
    this.userAgent = ctx.userAgent
    this.isServerSide = typeof window === 'undefined'
    this.lang = ctx.lang
    this.lastLoginType = ctx.lastLoginType
    this.lastLoginDate = ctx.lastLoginDate
    if (api) {
      this.api = api
      return
    }

    const apiBaseURL = this.isServerSide
      ? `${
          ctx.host.includes('localhost') || ctx.host.match(/\d/) || process.env.FORCE_HTTP === '1'
            ? 'http'
            : 'https'
        }://${ctx.host}/api/next/`
      : '/api/next/'

    this.api = axios.create({
      baseURL: apiBaseURL,
      headers: {
        'x-auth': ctx.isAuthorized,
        ...(this.isServerSide && ctx.cookie && { cookie: ctx.cookie }),
        ...(this.isServerSide && ctx.ip && { 'x-forwarded-for': ctx.ip }),
        ...(this.isServerSide && ctx.userAgent && { 'user-agent': ctx.userAgent }),
      },
      withCredentials: true,
      validateStatus: (status) => (status >= 200 && status < 300) || status === 429,
    })
  }

  private get = async <TResponse>(strings: TemplateStringsArray, ...params: any[]) => {
    const route = strings.reduce((acc, val, i) => acc + val + (params[i] ?? ''), '')

    const apiResponse = await this.api.get<TResponse>(route)

    return apiResponse.data
  }

  private post = <TResponse>(strings: TemplateStringsArray, ...params: any[]) => {
    const route = strings.reduce((acc, val, i) => acc + val + (params[i] ?? ''), '')

    return async (data?: object | FormData, config?: AxiosRequestConfig) => {
      const apiResponse = await this.api.post<object | FormData, AxiosResponse<TResponse>>(
        route,
        data,
        config
      )
      return apiResponse.data
    }
  }

  getCurrentUser = async () => {
    const res = await this.api.get<User>('/user/current/', {
      headers: { ...(this.cookie && { Cookie: this.cookie }), 'x-auth': true },
    })

    return [res.data, res.headers['set-cookie'] as string | string[]] as const
  }

  getMallList = () => this.get<Mall[]>`/mall/list/`

  getMallInfo = (code: string) => this.get<Mall>`/mall/${code}/info/`

  getProductInfo = (mall: string, id: string) => this.get<ProductInfo>`/product/${mall}/info/${id}/`

  getProductsInfo = (ids: string[]) =>
    this.post<ProductInfo[]>`/product/${this.currentMall.code}/info/`({ ids })

  getFavoriteLists = () => this.get<FavoriteList[]>`/favorites/${this.currentMall.code}/lists/`

  getFavoriteListsForProduct = (id: number) =>
    this.get<FavoriteList[]>`/favorites/${this.currentMall.code}/product/${id}/lists/`

  createFavoriteList = (name: string) =>
    this.post<FavoriteList>`/favorites/${this.currentMall.code}/list/add/`({ name })

  renameFavoriteList = (id: number, name: string) =>
    this.post<FavoriteList>`/favorites/${this.currentMall.code}/list/${id}/rename/`({ name })

  deleteFavoriteList = (id: number) =>
    this.post<FavoriteList>`/favorites/${this.currentMall.code}/list/${id}/delete/`({})

  addToFavoriteList = (listId: number, id: number) =>
    this.post<FavoriteList>`/favorites/${this.currentMall.code}/list/${listId}/product/add/`({
      productId: id,
    })

  removeFromFavoriteList = (listId: number, id: number) =>
    this.post<FavoriteList>`/favorites/${this.currentMall.code}/list/${listId}/product/remove/`({
      productId: id,
    })

  getFavoriteListProducts = (id: number, filter: ProductListFilter, abortSignal?: AbortSignal) =>
    this.post<
      ListingDTO<ProductListItem>
    >`/favorites/${this.currentMall.code}/list/${id}/products/list/`(filter, {
      signal: abortSignal,
    })

  startFavoriteListProductsExport = (id: number, filter: ProductListFilter) =>
    this
      .post<StartExportResponse>`/favorites/${this.currentMall.code}/list/${id}/products/list/export/`(
      filter
    )

  getMetricsAggregate = (id: number, period: number) =>
    this
      .get<MetricsComparison>`/product/${this.currentMall.code}/aggregations-period/${id}/days/${period}/`

  getProductMetricsAggregate = ({
    productId,
    from,
    to,
    inventoryType,
    salesCountry,
  }: {
    productId: number
    from?: ISO8601DateString
    to?: ISO8601DateString
    inventoryType?: InventoryType
    salesCountry?: string
  }) =>
    this.post<MetricsComparison>`/product/${this.currentMall.code}/aggregations/${productId}/`({
      from: from ?? null,
      to: to ?? null,
      inventoryType,
      ...(this.currentMall.code === 'wb' && salesCountry ? { salesCountry } : {}),
    })

  getVariationAggregates = ({
    productId,
    from,
    to,
  }: {
    productId: number
    from?: ISO8601DateString
    to?: ISO8601DateString
  }) =>
    this.post<
      ProductVariationAggregates[]
    >`/product/${this.currentMall.code}/variations-aggregations/${productId}/`({
      from: from ?? null,
      to: to ?? null,
    })

  getChartData = <T extends MetricsChartType>(
    id: number,
    chartType: T,
    from?: ISO8601DateString,
    to?: ISO8601DateString,
    inventoryType?: InventoryType,
    salesCountry?: string
  ) =>
    this.post<
      T extends 'prices' ? PriceChartDataPoint[] : ChartDataPoint[]
    >`/product/${this.currentMall.code}/single-chart/${id}/${chartType}/`({
      from,
      to,
      inventoryType,
      ...(this.currentMall.code === 'wb' &&
        ['sales', 'gmv', 'sales_agg', 'gmv_agg'].includes(chartType) &&
        salesCountry
        ? { salesCountry }
        : {}),
    })

  getOfferChartData = <T extends OfferChartType>({
    variationId,
    merchantId,
    chartType,
  }: {
    variationId: number
    merchantId: number
    chartType: T
  }) =>
    this.post<
      ChartDataPoint[]
    >`/product/${this.currentMall.code}/offer-chart/${variationId}/${merchantId}/${chartType}/`({})

  getWarehouseChartData = <T extends WarehouseChartType>({
    productId,
    warehouseId,
    chartType,
    variationId,
    from,
    to,
  }: {
    productId: number
    chartType: T
    warehouseId?: string
    variationId?: number
    from?: ISO8601DateString
    to?: ISO8601DateString
  }) =>
    this.post<
      ChartDataPoint[]
    >`/product/${this.currentMall.code}/warehouse-chart/${productId}/${chartType}/`({
      from: from ?? null,
      to: to ?? null,
      variationId: variationId ?? null,
      warehouseId: warehouseId ?? null,
    })

  getVariantChartData = <T extends VariantChartType>({
    productId,
    variationId,
    chartType,
    from,
    to,
  }: {
    productId: number
    variationId: number
    chartType: T
    from?: ISO8601DateString
    to?: ISO8601DateString
  }) =>
    this.post<
      ChartDataPoint[]
    >`/product/${this.currentMall.code}/variation-chart/${productId}/${variationId}/${chartType}/`({
      from: from ?? null,
      to: to ?? null,
    })

  getContentChart = (id: number) =>
    this.post<ContentChartDataPoint[]>`/product/${this.currentMall.code}/content/${id}/chart/`({})

  getContentStats = (id: number) =>
    this.get<ContentStats>`/product/${this.currentMall.code}/content/${id}/stat/`

  getFeedsList = (id: number) =>
    this.get<Feed[]>`/product/${this.currentMall.code}/feeds/${id}/list/`

  getFeedChart = (
    productId: number,
    feedId: number,
    feedType: keyof typeof FeedTypes,
    from?: ISO8601DateString,
    to?: ISO8601DateString
  ) =>
    this.post<
      FeedChartDataPoint[]
    >`/product/${this.currentMall.code}/feeds/${productId}/feed/${feedId}/${feedType}/chart/`(
      from && to
        ? {
            from,
            to,
          }
        : {}
    )

  getFeedChartPositions = (productId: number, request: FeedChartPositionsRequest) =>
    this.post<FeedChartPositions[]>`/product/${this.currentMall.code}/feeds/${productId}/charts/`(
      request
    )

  startFeedsChartsExport = (
    productId: number,
    request: Omit<FeedChartPositionsRequest, 'feedsIds'>
  ) =>
    this
      .post<StartExportResponse>`/product/${this.currentMall.code}/feeds/${productId}/charts/export/`(
      request
    )

  getFeedProducts = (
    feedType: FeedType,
    feedId: number,
    filter: ProductListFilter,
    signal: AbortSignal
  ) =>
    this.post<
      ListingDTO<ProductListItem> & { feedId: number }
    >`/feeds/${this.currentMall.code}/${feedId}/${ReverseFeedTypes[feedType]}/products/`(filter, {
      signal,
    })

  getCountryList = () => this.get<Country[]>`/countries/${this.currentMall.code}/list/`

  getReviews = (productId: number, filter: ProductReviewFilter = {}) =>
    this.post<ProductReview[]>`/product/${this.currentMall.code}/reviews/${productId}/list/`(filter)

  getReviewsByStar = (productId: number) =>
    this.get<ReviewsByStar[]>`/product/${this.currentMall.code}/reviews/${productId}/distribution/`

  getReviewsByCountry = (productId: number) =>
    this.get<ReviewsByCountry[]>`/product/${this.currentMall.code}/reviews/${productId}/geo/list/`

  getProductTimeline = (productId: number) =>
    this.get<TimelineEvent[]>`/product/${this.currentMall.code}/events/${productId}/`

  updateUserFullname = (name: string) => this.post<User>`/user/update-info/`({ fullName: name })

  updateUserPassword = (oldPassword: string, newPassword: string) =>
    this.post`/user/change-password/`({
      oldPassword,
      newPassword,
    })

  getBrandGroups = () => this.get<BrandGroup[]>`/user/brands-groups/`

  getUserSubscription = () => this.get<Subscription>`/user/subscription/active/`

  requestExtraPlan = () => this.post`/user/subscription/request-extra-tariff/`({})

  enableSubscriptionRenew = (subscriptionId: number) =>
    this.post<Subscription>`/subscription/${subscriptionId}/renew/enable/`({})

  disableSubscriptionRenew = (subscriptionId: number) =>
    this.post<Subscription>`/subscription/${subscriptionId}/renew/disable/`({})

  getUserTariffs = () => this.get<SubscriptionTariffs>`/subscription/tariffs/`

  relinkCard = (subscriptionId: number) =>
    this.post<{ url: string }>`/subscription/${subscriptionId}/relink-card/`({})

  createSubscription = (request: SubscriptionRequest) =>
    this.post<SubscriptionResponse>`/subscription/create/`(request)

  requestSubscriptionPayment = (request: SubscriptionRequest) =>
    this.post<[]>`/subscription/request-payment-on-account/`(request)

  getCustomOffer = (id: number, uuid: string) => this.get<CustomOffer>`/custom-offer/${id}/${uuid}/`

  payCustomOffer = (id: number, uuid: string) =>
    this.post<CustomOfferPaymentResponse>`/custom-offer/${id}/${uuid}/pay/`({})

  getExportList = (page: number, pageSize: number) =>
    this.get<ExportList>`/reports/list/?page=${page}&pageSize=${pageSize}`

  getDocumentList = (page: number, pageSize: number) =>
    this.get<DocumentList>`/documents/list/?page=${page}&pageSize=${pageSize}`

  removeReport = (id: number) => this.post`/reports/${id}/hide/`({})

  getProductOffers = (id: number) =>
    this.get<ProductOffers>`/product/${this.currentMall.code}/offers/${id}/`

  getEntityNamesByIds = <T extends 'brands' | 'merchants' | 'categories' | 'subjects'>(
    entity: T,
    ids: number[],
    abortSignal?: AbortSignal
  ) =>
    this.post<
      T extends 'categories'
        ? Category[]
        : T extends 'subjects'
          ? Subject[]
          : AutocompleteSuggestion[]
    >`/${entity}/${this.currentMall.code}/ids/`(
      {
        ids,
      },
      { signal: abortSignal }
    )

  getNameSuggestion = (
    entity: 'brands' | 'merchants' | 'categories',
    name?: string,
    limit?: number
  ) =>
    this.post<AutocompleteSuggestion[]>`/${entity}/${this.currentMall.code}/suggest/`({
      name,
      limit,
    })

  getProductTagsList = () => this.get<ProductTag[]>`/tags/${this.currentMall.code}/list/`

  getAvailableCharacteristics = (filter: ProductListFilter) =>
    this.post<
      AvailableCharacteristic[]
    >`/products/${this.currentMall.code}/characteristics/available/`(filter)

  getCharacteristicValues = (characteristicCode: string, filter: ProductListFilter) =>
    this.post<CharacteristicValue[]>`/products/${this.currentMall.code}/characteristics/suggest/`({
      characteristicCode,
      ...filter,
      limit: ['color', 'country'].includes(characteristicCode) ? 100 : 5,
    })

  getProductList = (mall: string, filter: ProductListFilter, abortSignal?: AbortSignal) =>
    this.post<ListingDTO<ProductListItem>>`/products/${mall}/list/`(filter, {
      signal: abortSignal,
    })

  getProductListItemsSummary = (filter: ProductListFilter, abortSignal?: AbortSignal) =>
    this.post<ProductListItemsSummary>`/products/${this.currentMall.code}/list/summary/`(filter, {
      signal: abortSignal,
    })

  getProductSalesCountries = (
    filter: Omit<ProductListFilter, 'salesCountry' | 'sort' | 'after' | 'limit'>,
    abortSignal?: AbortSignal
  ) =>
    this.post<ProductSalesCountry[]>`/products/${this.currentMall.code}/list/countries/`(
      { ...filter, salesCountry: undefined, after: undefined, sort: 'sales_desc', limit: 10 },
      { signal: abortSignal }
    )

  getPresetsByType = (type: FilterPresetType) =>
    this.get<FilterPresetInfo[]>`/presets/${this.currentMall.code}/list/${type}/`

  getFilterPreset = (id: number) => this.get<FilterPreset>`/presets/${id}/`

  addFilterPreset = (name: string, type: FilterPresetType, data: string) =>
    this.post<FilterPreset>`/presets/${this.currentMall.code}/add/`({ name, type, data })

  deleteFilterPreset = (id: number) => this.post<[]>`/presets/${id}/delete/`({})

  getProductNameVersions = (id: number) =>
    this.get<ProductNameVersion[]>`/product/${this.currentMall.code}/name/${id}/versions/`

  getProductDescriptionVersions = (id: number) =>
    this.get<string[]>`/product/${this.currentMall.code}/description/${id}/versions/`

  getProductDescription = (id: number, versions: string[]) =>
    this.post<
      ProductDescriptionVersion[]
    >`/product/${this.currentMall.code}/description/${id}/texts/`({ versions })

  //
  //
  // EXPORTS METHODS
  //

  startProductListExport = (mall: string, filter: ProductListFilter) =>
    this.post<StartExportResponse>`/products/${mall}/list/export/`(filter)

  startQueryMonitoringExport = (mall: string, filter: QueryMonitoringExportFilter = {}) =>
    this.post<StartExportResponse>`/storage/queryMonitoringStorage/${mall}/export/`(filter)

  startFeedListExport = (productId: number) =>
    this
      .post<StartExportResponse>`/product/${this.currentMall.code}/feeds/${productId}/list/export/`(
      {}
    )

  startFeedExport = (productId: number, feedId: number, feedType: number) =>
    this
      .post<StartExportResponse>`/product/${this.currentMall.code}/feeds/${productId}/feed/${feedId}/${feedType}/chart/export/`(
      {}
    )

  startReviewsExport = (productId: number, filter: ProductReviewFilter = {}) =>
    this
      .post<StartExportResponse>`/product/${this.currentMall.code}/reviews/${productId}/list/export/`(
      filter
    )

  startChartsExport = (productId: number) =>
    this.post<StartExportResponse>`/product/${this.currentMall.code}/charts/${productId}/export/`(
      {}
    )

  startOffersExport = (productId: number) =>
    this.post<StartExportResponse>`/product/${this.currentMall.code}/offers/${productId}/export/`(
      {}
    )

  startOfferChartExport = (variantId: number, merchantId: number) =>
    this
      .post<StartExportResponse>`/product/${this.currentMall.code}/offer-charts/${variantId}/${merchantId}/export/`(
      {}
    )

  startWarehouseChartExport = ({
    productId,
    warehouseId,
    variationId,
    from,
    to,
  }: {
    productId: number
    warehouseId?: string
    variationId?: number
    from?: ISO8601DateString
    to?: ISO8601DateString
  }) =>
    this
      .post<StartExportResponse>`/product/${this.currentMall.code}/warehouse-charts/${productId}/export/`(
      {
        from: from ?? null,
        to: to ?? null,
        variationId: variationId ?? null,
        warehouseId: warehouseId ?? null,
      }
    )

  startEventsExport = (productId: number) =>
    this.post<StartExportResponse>`/product/${this.currentMall.code}/events/${productId}/export/`(
      {}
    )

  startBusinessProductListExport = (
    mall: MallCode,
    filter: BusinessSalesProductListFilter,
    sellersWorkScheme: SellersWorkScheme,
    exportWithSizes?: boolean
  ) =>
    this.post<StartExportResponse>`/mall-analytics/dashboard/${mall}/list/export/`(
      { ...filter, sellersWorkScheme, exportWithSizes }
    )

  startBusinessOrdersListExport = (filter: BusinessOrdersListFilter) =>
    this.post<StartExportResponse>`/mall-analytics/orders/${this.currentMall.code}/list/export/`(
      filter
    )

  startCategoryStatExport = (mall: string, filter: CategoryListFilter) =>
    this.post<StartExportResponse>`/category-stat/${mall}/list/export/`({
      from: filter.from,
      to: filter.to,
      categoryId: filter.categoryId,
      brandsIds: filter.brandsIds,
      merchantsIds: filter.merchantsIds,
      inventoryType: filter.inventoryType,
    })

  startKeywordListExport = (filter: KeywordListFilter) =>
    this.post<StartExportResponse>`/keywords/${this.currentMall.code}/list/export/`(filter)

  startKeywordProductListExport = (feedId: number, feedType: 1 | 2 | 3 | 4 | 6) =>
    this
      .post<StartExportResponse>`/feeds/${this.currentMall.code}/${feedId}/${feedType}/products/export/`(
      {}
    )

  //
  //
  // CATEGORIES METHODS
  //

  getCategoryTree = () => this.get<CategoryTree[]>`/categories/${this.currentMall.code}/tree/`

  getSubjectTree = () => this.get<SubjectTree[]>`/subjects/${this.currentMall.code}/tree/`

  getCategoriesIds = (ids: number[]) =>
    this.post<CategoryTree[]>`/categories/${this.currentMall.code}/ids/`({ ids })

  getCategoriesByBrands = (brands: number[]) =>
    this.post<number[]>`/categories/${this.currentMall.code}/brands-categories/`({ ids: brands })

  getCategoriesLastUpdated = () =>
    this.get<{
      lastDate: ISO8601DateTimeString | null
    }>`/category-stat/${this.currentMall.code}/last-date/`

  getNicheList = (mall: string, filter: NicheListFilter, abortSignal?: AbortSignal) =>
    this.post<NicheObservationListResponse>`/niche/${mall}/list/`(filter, { signal: abortSignal })

  getCategoryStats = (mall: string, filter: CategoryListFilter, abortSignal?: AbortSignal) =>
    this.post<CategoryList>`/category-stat/${mall}/list/`(
      {
        from: filter.from,
        to: filter.to,
        categoryId: filter.categoryId,
        brandsIds: filter.brandsIds,
        merchantsIds: filter.merchantsIds,
        limit: filter.limit,
        after: filter.after,
        sort: filter.sort ?? 'gmv_desc',
        inventoryType: filter.inventoryType,
      },
      {
        signal: abortSignal,
      }
    )

  getCategoryStatSummary = (mall: string, filter: CategoryListFilter, abortSignal?: AbortSignal) =>
    this.post<CategoryStat>`/category-stat/${mall}/summary/`(
      {
        from: filter.from,
        to: filter.to,
        categoryId: filter.categoryId,
        inventoryType: filter.inventoryType,
        brandsIds: filter.brandsIds,
        merchantsIds: filter.merchantsIds,
      },
      {
        signal: abortSignal,
      }
    )

  getCategoryStatCharts = (query: CategoryStatChartsQuery) =>
    this.post<CategoryStatCharts>`/category-stat/${this.currentMall.code}/chart/`(query)

  getCategoryPriceDistribution = (
    categoryId: number,
    filter: CategoryListFilter,
    signal?: AbortSignal
  ) =>
    this.post<
      CategoryPriceRange[]
    >`/category-stat/${this.currentMall.code}/${categoryId}/price-distribution/`(
      {
        from: filter.from,
        to: filter.to,
        brandsIds: filter.brandsIds,
        merchantsIds: filter.merchantsIds,
        inventoryType: filter.inventoryType,
      },
      { signal }
    )

  getCategoryPriceSegment = (
    categoryId: number,
    entity: CategoryPriceSegmentEntity,
    filter: CategoryPriceSegmentFilter,
    signal: AbortSignal
  ) =>
    this.post<{
      items: CategoryPriceSegmentItem[]
      hasMore: boolean
    }>`/category-stat/${this.currentMall.code}/${categoryId}/price-distribution/${entity}/`(
      filter,
      { signal }
    )

  getSubjectsIds = (ids: number[]) =>
    this.post<SubjectTree[]>`/subjects/${this.currentMall.code}/ids/`({ ids })

  getSubjectsLastUpdated = () =>
    this.get<{
      lastDate: ISO8601DateTimeString | null
    }>`/subject-stat/${this.currentMall.code}/last-date/`

  getSubjectStats = (mall: string, filter: SubjectListFilter, abortSignal?: AbortSignal) =>
    this.post<SubjectList>`/subject-stat/${mall}/list/`(
      {
        from: filter.from,
        to: filter.to,
        subjectId: filter.subjectId,
        brandsIds: filter.brandsIds,
        merchantsIds: filter.merchantsIds,
        limit: filter.limit,
        after: filter.after,
        sort: filter.sort ?? 'gmv_desc',
        inventoryType: filter.inventoryType,
      },
      {
        signal: abortSignal,
      }
    )

  getSubjectStatSummary = (mall: string, filter: SubjectListFilter, abortSignal?: AbortSignal) =>
    this.post<SubjectStat>`/subject-stat/${mall}/summary/`(
      {
        from: filter.from,
        to: filter.to,
        subjectId: filter.subjectId,
        inventoryType: filter.inventoryType,
        brandsIds: filter.brandsIds,
        merchantsIds: filter.merchantsIds,
      },
      {
        signal: abortSignal,
      }
    )

  getSubjectStatCharts = (query: SubjectStatChartsQuery) =>
    this.post<SubjectStatCharts>`/subject-stat/${this.currentMall.code}/chart/`(query)

  getSubjectPriceDistribution = (subjectId: number, filter: SubjectListFilter) =>
    this.post<
      SubjectPriceRange[]
    >`/subject-stat/${this.currentMall.code}/${subjectId}/price-distribution/`({
      from: filter.from,
      to: filter.to,
      brandsIds: filter.brandsIds,
      merchantsIds: filter.merchantsIds,
      inventoryType: filter.inventoryType,
    })

  startSubjectStatExport = (mall: string, filter: SubjectListFilter) =>
    this.post<StartExportResponse>`/subject-stat/${mall}/list/export/`({
      from: filter.from,
      to: filter.to,
      subjectId: filter.subjectId,
      brandsIds: filter.brandsIds,
      merchantsIds: filter.merchantsIds,
      inventoryType: filter.inventoryType,
    })

  //
  //
  // MERCHANT AND BRAND LIST METHODS
  //

  getBrandStatList = (filter: CategoryListFilter, signal: AbortSignal) =>
    this.post<ListingDTO<CategoryStatBrand>>`/brand-stat/${this.currentMall.code}/list/`(filter, {
      signal,
    })

  getMerchantStatList = (filter: CategoryListFilter, signal: AbortSignal) =>
    this.post<ListingDTO<CategoryStatMerchant>>`/merchant-stat/${this.currentMall.code}/list/`(
      filter,
      { signal }
    )

  startBrandStatListExport = (filter: CategoryListFilter) =>
    this.post<StartExportResponse>`/brand-stat/${this.currentMall.code}/list/export/`(filter)

  startMerchantStatListExport = (filter: CategoryListFilter) =>
    this.post<StartExportResponse>`/merchant-stat/${this.currentMall.code}/list/export/`(filter)

  getBrandStatChart = (query: CategoryStatChartsQuery) =>
    this.post<CategoryStatCharts>`/brand-stat/${this.currentMall.code}/chart/`(query)

  getMerchantStatChart = (query: CategoryStatChartsQuery) =>
    this.post<CategoryStatCharts>`/merchant-stat/${this.currentMall.code}/chart/`(query)

  //
  //
  // KEYWORDS METHODS
  //

  getKeywordList = (filter: KeywordListFilter, signal: AbortSignal) =>
    this.post<ListingDTO<Keyword>>`/keywords/${this.currentMall.code}/list/`(filter, { signal })

  getKeywordBrands = (feedId: number) =>
    this.get<KeywordBrand[]>`/keywords/${this.currentMall.code}/brands/${feedId}/`

  getKeywordMerchants = (feedId: number) =>
    this.get<KeywordMerchant[]>`/keywords/${this.currentMall.code}/merchants/${feedId}/`

  getKeywordQuantiles = () =>
    this.post<QuantileResponse>`/keywords/${this.currentMall.code}/quantiles/`({
      metrics: ['competition'],
      quantiles: [0.05, 0.1, 0.2, 0.5],
    } as QuantileRequest)

  getKeywordCharts = (feedId: number) =>
    this.get<KeywordStatValue[]>`/keywords/${this.currentMall.code}/${feedId}/charts/`

  startKeywordChartsExport = (phraseId: number) =>
    this.post<StartExportResponse>`/keywords/${this.currentMall.code}/${phraseId}/charts/export/`({})

  getUserKeywordList = ({
    page,
    pageSize,
    query,
  }: {
    page: number
    pageSize: number
    query: string
  }) =>
    this.get<UserKeywordList>`/user-keywords/list/?page=${page}&pageSize=${pageSize}&query=${query}`

  getUserKeywordStats = () => this.get<UserKeywordStats>`/user-keywords/stats/`

  addUserKeyword = (mall: MallCode, text: string) =>
    this.post<UserKeyword>`/user-keywords/${mall}/add/`({ text })

  deleteUserKeyword = (id: number) => this.post<[]>`/user-keywords/${id}/delete/`({})

  //
  // BUSINESS API-KEYS METHODS
  //

  getBusinessAccounts = (options: { malls?: MallCode[]; signal?: AbortSignal }) => {
    const malls = options.malls
    const signal = options?.signal

    return this
      .post<BusinessUserStore[]>`/mall-analytics/account/list/`(
        malls !== undefined ? { malls } : {},
        { signal }
      )
      .then((stores) =>
        stores.map((store) => ({
          ...store,
          apiTokens: store.apiTokens.map((token) => ({
            ...token,
            apiToken:
              this.user?.roles.includes('ROLE_SUPER_ADMIN') ||
              (this.user?.switched && this.user?.originalUser?.roles.includes('ROLE_SUPER_ADMIN'))
                ? token.token
                : '*'.repeat(token.token.length - 4) + token.token.slice(-4),
          })),
        }))
      )
  }

  decodeBusinessApiTokens = (
    apiTokens: BusinessUserApiTokenCreationList,
    marketplaceSellerAccountId?: string
  ) =>
    this
      .post<BusinessDecodeApiTokenResponse>`/mall-analytics/account/${this.currentMall.code}/decode-api-tokens/`(
      {
        apiTokens,
        marketplaceSellerAccountId,
      }
    )

  createBusinessAccount = (value: {
    name: string
    apiTokens: BusinessUserApiTokenCreationList
    marketplaceSellerAccountId?: string
  }) =>
    this.post<BusinessUserStore>`/mall-analytics/account/${this.currentMall.code}/create/`({
      name: value.name,
      apiTokens: value.apiTokens,
      marketplaceSellerAccountId: value.marketplaceSellerAccountId,
    })

  updateBusinessAccount = (
    apiKeyId: number,
    value: { name?: string; lastDays?: number | null; ai?: BusinessReviewsAISettings }
  ) =>
    this.post<BusinessUserStore>`/mall-analytics/account/${apiKeyId}/update/`({
      name: value.name,
      lastDays: value.lastDays,
      ai: value.ai,
    })

  updateBusinessAccountTaxSettings = (
    apiKeyId: number,
    value: {
      taxSchemeHistory: MarketplaceAccountTaxScheme[] | null
    }
  ) =>
    this.post<BusinessUserStore>`/mall-analytics/account/${apiKeyId}/update-tax-settings/`({
      taxSchemeHistory: value.taxSchemeHistory,
    })

  deleteBusinessAccount = (apiKeyId: number) =>
    this.post`/mall-analytics/account/${apiKeyId}/delete/`({})

  replaceBusinessApiTokens = (apiKeyId: number, apiTokens: BusinessUserApiTokenCreationList) =>
    this.post<BusinessUserStore>`/mall-analytics/account/${apiKeyId}/change-api-tokens/`({
      apiTokens,
    })

  enableBusinessReviews = (apiKeyId: number) =>
    this.post<BusinessUserStore>`/autoreplier/account/${this.currentMall.code}/${apiKeyId}/enable/`(
      {}
    )

  disableBusinessReviews = (apiKeyId: number) =>
    this
      .post<BusinessUserStore>`/autoreplier/account/${this.currentMall.code}/${apiKeyId}/disable/`(
      {}
    )

  getBusinessProductList = (
    marketplaceAccountId?: number,
    search?: string[],
    after?: number,
    limit?: number,
    mall: MallCode = this.currentMall.code
  ) =>
    this.post<
      BusinessProductNoStats[]
    >`/mall-analytics/dashboard/${mall}/products/`({
      marketplaceAccountId,
      search,
      after,
      limit,
    })

  //
  //
  // BUSINESS SALES METHODS
  //

  getBusinessSalesStats = (
    filter: {
      from: string
      to: string
      brandId: number[]
      sellersWorkScheme: SellersWorkScheme
      malls: MallCode[]
      marketplaceAccountIds?: number[]
      skus?: string[]
      byOrderDate: boolean
    },
    signal?: AbortSignal
  ) =>
    this.post<BusinessSalesStats>`/mall-analytics/dashboard/stats/`(filter, { signal })

  getBusinessSalesChartData = (
    filter: {
      from: string
      to: string
      brandId: number[]
      sellersWorkScheme: SellersWorkScheme
      malls: MallCode[]
      marketplaceAccountIds?: number[]
      skus?: string[]
      byOrderDate: boolean
    },
    signal?: AbortSignal
  ) =>
    this.post<BusinessSalesChartData[]>`/mall-analytics/dashboard/graph/`(filter, { signal })

  getBusinessSalesProductChartData = (mall: MallCode, filter: BusinessSalesProductChartRequest) =>
    this
      .post<BusinessSalesProductChartData>`/mall-analytics/dashboard/${mall}/product/charts/`(
      filter
    )

  getBusinessSalesProducts = (
    mall: MallCode,
    filter: BusinessSalesProductListFilter,
    signal?: AbortSignal
  ) =>
    this.post<BusinessSalesProductList>`/mall-analytics/dashboard/${mall}/list/`(
      filter,
      { signal }
    )

  getBusinessSalesBrands = (
    apiKeyIdOrFilter?:
      | number
      | {
          malls: MallCode[]
          marketplaceAccountIds?: number[]
        },
    mall: MallCode = this.currentMall.code,
    signal?: AbortSignal
  ) =>
    typeof apiKeyIdOrFilter === 'object'
      ? this.post<BusinessSalesBrand[]>`/mall-analytics/dashboard/brands/`(
          {
            malls: apiKeyIdOrFilter.malls,
            marketplaceAccountIds: apiKeyIdOrFilter.marketplaceAccountIds,
          },
          { signal }
        )
      : this.post<BusinessSalesBrand[]>`/mall-analytics/dashboard/brands/`(
          {
            malls: [mall],
            marketplaceAccountIds:
              apiKeyIdOrFilter !== undefined ? [apiKeyIdOrFilter] : undefined,
          },
          { signal }
        )

  //
  // BUSINESS STOCKS METHODS
  //

  getBusinessStockStatWarehouses = (filter: BusinessStockStatScope, signal?: AbortSignal) =>
    this.post<BusinessStockStatWarehouse[]>`/mall-analytics/stock-stat/warehouse/list/`(filter, {
      signal,
    })

  getBusinessStockStatProducts = (
    filter: BusinessStockStatProductListRequest,
    signal?: AbortSignal
  ) =>
    this.post<BusinessStockStatProductList>`/mall-analytics/stock-stat/list/`(filter, {
      signal,
    })

  getBusinessStockStatSummary = (filter: BusinessStockStatFilter, signal?: AbortSignal) =>
    this.post<BusinessStockStatSummary>`/mall-analytics/stock-stat/summary/`(filter, { signal })

  checkNullPrimeCosts = (options: {
    from: ISO8601DateString
    to: ISO8601DateString
    marketplaceAccountId?: number
  }) =>
    this.post<{
      hasNullPrimeCosts: boolean
    }>`/mall-analytics/prime-cost/${this.currentMall.code}/check/`(options)

  updatePrimeCost = (mall: MallCode, { productSku, primeCost, size, date }: UpdatePrimeCostRequest) =>
    this
      .post<PrimeCostResponse>`/mall-analytics/prime-cost/${mall}/article/${productSku}/update/`(
      { primeCost, size, date }
    )

  deletePrimeCost = (mall: MallCode, { productSku, size, date }: DeletePrimeCostRequest) =>
    this.post<[]>`/mall-analytics/prime-cost/${mall}/article/${productSku}/delete/`({
      size,
      date,
    })

  deleteAllPrimeCosts = (
    mall: MallCode,
    marketplaceAccountId?: number,
    date?: ISO8601DateString
  ) =>
    this.post<[]>`/mall-analytics/prime-cost/${mall}/delete-all/`({
      marketplaceAccountId,
      date,
    })

  setPrimeCostsFromMayak = (mall: MallCode, marketplaceAccountId?: number) =>
    this.post<[]>`/mall-analytics/prime-cost/${mall}/set-from-mayak/`({
      marketplaceAccountId,
    })

  uploadPrimeCostFile = (mall: MallCode, file: File, date?: ISO8601DateString) => {
    const formData = new FormData()
    formData.append('file', file)
    if (date) {
      formData.append('date', date)
    }
    return this.api.post<[] | FormValidationErrors>(
      `/mall-analytics/prime-cost/${mall}/upload/`,
      formData
    )
  }

  getPrimeCostShipments = (mall: MallCode, request: { article?: string; size?: string }) =>
    this.post<
      ListingDTO<ISO8601DateString>
    >`/mall-analytics/prime-cost/${mall}/shipments/`(request)

  getPrimeCostListForProduct = (
    mall: MallCode,
    request: { article: string; size?: string }
  ) =>
    this.post<
      ListingDTO<PrimeCostChange>
    >`/mall-analytics/prime-cost/${mall}/list-for-product/`(request)

  getPrimeCostListForShipment = (
    mall: MallCode,
    { date, name, search, sort }: PrimeCostForShipmentRequest
  ) =>
    this.post<
      ListingDTO<PrimeCostForShipment>
    >`/mall-analytics/prime-cost/${mall}/list-for-shipment/`({
      date,
    })

  updateAdditionalExpensesPerOrder = (
    mall: MallCode,
    article: string,
    additionalExpensesPerOrderPrice: number,
    size?: string,
    date?: ISO8601DateString
  ) =>
    this.post<unknown>`/mall-analytics/additional-expenses-per-order/${mall}/article/${article}/update/`({
      additionalExpensesPerOrderPrice,
      size,
      date,
    })

  bulkUpdateAdditionalExpensesPerOrder = (
    mall: MallCode,
    items: { article: string; additionalExpensesPerOrderPrice: number; size?: string; date?: ISO8601DateString }[]
  ) => this.post<unknown>`/mall-analytics/additional-expenses-per-order/${mall}/bulk/`({ items })

  deleteAdditionalExpensesPerOrder = (
    mall: MallCode,
    article: string,
    size?: string,
    date?: ISO8601DateString
  ) =>
    this.post<unknown>`/mall-analytics/additional-expenses-per-order/${mall}/article/${article}/delete/`({
      size,
      date,
    })

  deleteAllAdditionalExpensesPerOrder = (mall: MallCode, marketplaceAccountId?: number) =>
    this.post<unknown>`/mall-analytics/additional-expenses-per-order/${mall}/delete-all/`({
      marketplaceAccountId,
    })

  getAdditionalExpensesPerOrderDates = async (mall: MallCode, marketplaceAccountId?: number) => {
    const result = await this.post<ListingDTO<ISO8601DateString> | ISO8601DateString[]>`/mall-analytics/additional-expenses-per-order/${mall}/dates/`({ marketplaceAccountId })
    return Array.isArray(result) ? { items: result, total: result.length } : result
  }

  getAdditionalExpensesPerOrderForDate = async (mall: MallCode, date: ISO8601DateString, marketplaceAccountId?: number, after = 0, limit = 20) => {
    const result = await this.post<ListingDTO<AdditionalExpensesPerOrderForDate> | { products: AdditionalExpensesPerOrderForDate[]; total: number }>`/mall-analytics/additional-expenses-per-order/${mall}/list-for-date/`({ date, marketplaceAccountId, after, limit })
    return 'items' in result ? result : { items: result.products, total: result.total }
  }

  getAdditionalExpensesPerOrderForProduct = async (mall: MallCode, article: string, size?: string) => {
    const result = await this.post<ListingDTO<AdditionalExpensesPerOrderChange> | AdditionalExpensesPerOrderChange[]>`/mall-analytics/additional-expenses-per-order/${mall}/list-for-product/`({ article, size })
    return Array.isArray(result) ? { items: result, total: result.length } : result
  }

  uploadAdditionalExpensesPerOrderFile = (mall: MallCode, file: File, date?: ISO8601DateString) => {
    const formData = new FormData()
    formData.append('file', file)
    if (date) formData.append('date', date)
    return this.api.post<[] | FormValidationErrors>(
      `/mall-analytics/additional-expenses-per-order/${mall}/upload/`,
      formData
    )
  }

  createBusinessSalesExpense = (mall: MallCode, expense: BusinessSalesExpenseCreateForm) =>
    this
      .post<BusinessSalesExpense>`/mall-analytics/additional-expense/${mall}/create/`(
      expense
    )

  updateBusinessSalesExpense = (
    mall: MallCode,
    id: number,
    expense: BusinessSalesExpense
  ) =>
    this
      .post<BusinessSalesExpense>`/mall-analytics/additional-expense/${mall}/${id}/update/`(
      expense
    )

  deleteBusinessSalesExpense = (mall: MallCode, expenseId: number) =>
    this
      .post<BusinessSalesExpense>`/mall-analytics/additional-expense/${mall}/${expenseId}/delete/`(
      {}
    )

  getBusinessSalesExpenseList = (
    mall: MallCode,
    filter: BusinessSalesExpenseFilter,
    signal?: AbortSignal
  ) =>
    this
      .post<BusinessSalesExpenseList>`/mall-analytics/additional-expense/${mall}/list/`(
      filter,
      { signal }
    )

  getBusinessSalesExpenseNameList = (mall: MallCode) =>
    this
      .post<BusinessSalesExpenseNameList>`/mall-analytics/additional-expense/${mall}/names/`(
      {}
    )

  //
  //
  // BUSINESS GEOGRAPHY METHODS
  //

  getOrdersGeographyList = (filter: OrdersGeographyListRequest, signal?: AbortSignal) =>
    this.post<OrdersGeographyList>`/mall-analytics/orders-geography/${this.currentMall.code}/list/`(
      filter,
      { signal }
    )

  getOrdersGeographyChart = (filter: OrdersGeographyChartRequest, signal?: AbortSignal) =>
    this
      .post<OrdersGeographyChart>`/mall-analytics/orders-geography/${this.currentMall.code}/chart/`(
      filter,
      { signal }
    )

  getOrdersGeographyMovementStat = (
    filter: OrdersMovementStatRequest,
    signal?: AbortSignal
  ) =>
    this
      .post<OrdersMovementStat>`/mall-analytics/orders-geography/${this.currentMall.code}/movement-stat/`(
      filter,
      { signal }
    )

  getOrdersGeographyMacroRegionsStat = (
    filter: OrdersGeographyMacroRegionsStatRequest,
    signal?: AbortSignal
  ) =>
    this
      .post<OrdersGeographyMacroRegionsStat>`/mall-analytics/orders-geography/${this.currentMall.code}/macro-regions-stat/`(
      filter,
      { signal }
    )

  //
  //
  // BUSINESS ORDERS METHODS
  //

  getBusinessOrdersList = (filter: BusinessOrdersListFilter, signal: AbortSignal) =>
    this.post<
      ListingDTO<BusinessOrdersListItem>
    >`/mall-analytics/orders/${this.currentMall.code}/list/`(filter, { signal })

  //
  //
  // BUSINESS STOPWORDS METHODS
  //

  getBusinessReviewsStopwordList = (sort: string, filter: BusinessReviewsStopwordFilter) =>
    this.post<BusinessReviewsStopword[]>`/autoreplier/stopword/${this.currentMall.code}/list/`({
      sort,
      text: filter.text,
      marketplaceAccountId: filter.marketplaceAccountId,
    })

  createBusinessReviewsStopword = (value: BusinessReviewsStopword, list: string[]) =>
    this.post`/autoreplier/stopword/${this.currentMall.code}/${value.marketplaceAccountId}/create/`(
      {
        list: list,
      }
    )

  updateBusinessReviewsStopword = (apiKeyId: number, value: BusinessReviewsStopword) =>
    this.post`/autoreplier/stopword/${this.currentMall.code}/${apiKeyId}/${value.id}/update/`({
      text: value.text,
      marketplaceAccountId: value.marketplaceAccountId,
    })

  daleteBusinessReviewsStopword = (apiKeyId: number, stopwordId: number) =>
    this.post`/autoreplier/stopword/${this.currentMall.code}/${apiKeyId}/${stopwordId}/delete/`({})

  //
  //
  // BUSINESS REVIEW TAGS METHODS
  //

  getBusinessReviewTags = (filter: BusinessReviewTagFilter) =>
    this.post<BusinessReviewTagsList>`/autoreplier/tags/${this.currentMall.code}/list/`({
      marketplaceAccountId: filter.marketplaceAccountId,
      marketplaceCode: filter.marketplaceCode,
      text: filter.text,
      sort: filter.sort,
    })

  createBusinessReviewTag = (value: {
    marketplaceAccountId: number
    title: string
    description?: string
  }) =>
    this
      .post<BusinessReviewCustomTag>`/autoreplier/tags/${this.currentMall.code}/${value.marketplaceAccountId}/create/`(
      {
        title: value.title,
        description: value.description,
      }
    )

  updateBusinessReviewTag = (
    apiKeyId: number,
    value: {
      marketplaceAccountId: number
      id: number
      description?: string
    }
  ) =>
    this
      .post<BusinessReviewCustomTag>`/autoreplier/tags/${this.currentMall.code}/${apiKeyId}/${value.id}/update/`(
      {
        description: value.description,
        marketplaceAccountId: apiKeyId,
        ...(value.marketplaceAccountId !== apiKeyId && {
          newMarketplaceAccountId: value.marketplaceAccountId,
        }),
      }
    )

  deleteBusinessReviewTag = (apiKeyId: number, tagId: number) =>
    this.post`/autoreplier/tags/${this.currentMall.code}/${apiKeyId}/${tagId}/delete/`({})

  //
  //
  // BUSINESS RULES METHODS
  //

  getBusinessReviewsRuleList = (sort: string, filter: BusinessReviewsRuleFilter) =>
    this.post<BusinessReviewsRule[]>`/autoreplier/rule/${this.currentMall.code}/list/`({
      sort,
      title: filter.title,
      productId: filter.productId,
      brandName: filter.brandName,
      templateId: filter.templateId,
      enabled: filter.enabled,
      tags: filter.tags,
      marketplaceAccountId: filter.marketplaceAccountId,
    })

  createBusinessReviewsRule = (value: BusinessReviewsRule) =>
    this
      .post<BusinessReviewsRule>`/autoreplier/rule/${this.currentMall.code}/${value.marketplaceAccountId}/create/`(
      {
        title: value.title,
        productsId: value.productsId,
        brandNames: value.brandNames,
        ratingRange: value.ratingRange,
        delimiterType: value.delimiterType,
        textParts: value.textParts,
        tags: value.tags,
        enabled: value.enabled,
        replyToEmptyReviews: value.replyToEmptyReviews,
        replyToNonEmptyReviews: value.replyToNonEmptyReviews,
        replyToMediaOnlyReviews: value.replyToMediaOnlyReviews,
        moderateBeforeSend: value.moderateBeforeSend,
      }
    )

  updateBusinessReviewsRule = (apiKeyId: number, value: BusinessReviewsRule) =>
    this
      .post<BusinessReviewsRule>`/autoreplier/rule/${this.currentMall.code}/${apiKeyId}/${value.id}/update/`(
      {
        title: value.title,
        productsId: value.productsId,
        brandNames: value.brandNames,
        ratingRange: value.ratingRange,
        delimiterType: value.delimiterType,
        textParts: value.textParts,
        tags: value.tags,
        enabled: value.enabled,
        marketplaceAccountId: value.marketplaceAccountId,
        replyToEmptyReviews: value.replyToEmptyReviews,
        replyToNonEmptyReviews: value.replyToNonEmptyReviews,
        replyToMediaOnlyReviews: value.replyToMediaOnlyReviews,
        moderateBeforeSend: value.moderateBeforeSend,
      }
    )

  daleteBusinessReviewsRule = (apiKeyId: number, ruledId: number) =>
    this.post`/autoreplier/rule/${this.currentMall.code}/${apiKeyId}/${ruledId}/delete/`({})

  enableBusinessReviewsRule = (apiKeyId: number, ruledId: number) =>
    this.post`/autoreplier/rule/${this.currentMall.code}/${apiKeyId}/${ruledId}/enable/`({})

  disableBusinessReviewsRule = (apiKeyId: number, ruledId: number) =>
    this.post`/autoreplier/rule/${this.currentMall.code}/${apiKeyId}/${ruledId}/disable/`({})

  generateBusinessReviewsRuleTextPart = (
    apiKeyId: number,
    body: BusinessReviewsRuleGenerateTextRequest
  ) =>
    this.post<BusinessReviewsRuleGenerateTextResponse>`/autoreplier/rule/${this.currentMall.code}/${apiKeyId}/text-part/generate/`(
      body
    )

  previewBusinessReviewReply = (apiKeyId: number, body: BusinessReviewsReplyPreviewRequest) =>
    this.post<BusinessReviewsReplyPreviewResponse>`/autoreplier/reply/${this.currentMall.code}/${apiKeyId}/preview/`(
      body
    )

  getBusinessReviewsLogs = (filter: BusinessReviewsLogRequest) =>
    this.post<BusinessReviewsLogListResponse>`/autoreplier/log/${this.currentMall.code}/list/`({
      marketplaceAccountId: filter.marketplaceAccountId,
      productId: filter.productId,
      offset: filter.offset,
      limit: filter.limit,
      publishStatus: filter.publishStatus,
      ratingRange: filter.ratingRange,
      tags: filter.tags,
      sort: filter.sort,
    })

  regenerateBusinessReviewReply = (
    apiKeyId: number,
    body: BusinessReviewsReplyRegenerateRequest
  ) =>
    this.post<BusinessReviewsReplyRegenerateResponse>`/autoreplier/reply/${this.currentMall.code}/${apiKeyId}/regenerate/`(
      body
    )

  performBusinessReviewReplyAction = (
    apiKeyId: number,
    body: BusinessReviewsReplyActionRequest
  ) =>
    this.post<{ status: string }>`/autoreplier/reply/${this.currentMall.code}/${apiKeyId}/action/`(
      body
    )

  //
  //
  // STORAGE METHODS
  //

  getStorage = <T extends keyof Storage>(key: T) => this.get<Storage[T]>`/storage/${key}/get/`

  setStorage = <T extends keyof Storage>(key: T, value: Storage[T]) =>
    this.post<Storage[T]>`/storage/${key}/set/`({ ...value })

  //
  //
  // BUSINESS BIDDER METHODS
  //

  getBidderCampaignList = (
    filter: BidderCampaignListFilter & { currency: string },
    signal: AbortSignal
  ) =>
    this.post<
      ListingDTO<BidderCampaignListItem> & BidderSyncResponse & { currency: string }
    >`/bidder/campaign/${this.currentMall.code}/list/`(filter, { signal })

  bidderCampaignStatExportRequest = (filter: BidderCampaignStatExportFilter) => ({
    href: `/api/export/bidder/campaign/${this.currentMall.code}/stat/download/`,
    body: filter,
  })

  bidderCampaignKeywordsExportRequest = (filter: BidderCampaignKeywordsExportFilter) => ({
    href: `/api/export/bidder/campaign/${this.currentMall.code}/keywords/download/`,
    body: filter,
  })

  getBidderCampaignInfo = (apiKeyId: number, campaignId: number, currency: string) =>
    this
      .get<BidderCampaignInfo>`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/info/?currency=${currency}`

  getBidderCampaignKeywords = (
    apiKeyId: number,
    campaignId: number,
    currency: string,
    options?: { from: ISO8601DateString | null; to: ISO8601DateString | null }
  ) =>
    this
      .post<BidderCampaignKeywords>`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/keywords/`(
      { ...options, currency }
    )

  syncBidderCampaignKeywords = (apiKeyId: number, campaignId: number) =>
    this
      .post<BidderSyncResponse>`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/keywords/sync/`(
      {}
    )

  getBidderCampaignAvailableProducts = (apiKeyId: number, campaignId: number) =>
    this.get<
      BidderCampaignProduct[]
    >`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/products-to-add/`

  updateBidderCampaignKeywords = (
    apiKeyId: number,
    campaignId: number,
    update: BidderCampaignKeywordsUpdate & { currency: string }
  ) =>
    this
      .post<BidderCampaignKeywords>`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/keywords/update/`(
      update
    )

  updateBidderCampaignInfo = (
    apiKeyId: number,
    campaignId: number,
    update: BidderCampaignUpdateInfo & { currency: string }
  ) =>
    this
      .post<BidderCampaignInfo>`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/update/`(
      update
    )

  getBidderCampaignStat = (
    apiKeyId: number,
    campaignId: number,
    options: {
      currency: string
      from?: ISO8601DateString
      to?: ISO8601DateString
      granularity?: 'days' | 'hours'
      sku?: string
      clusterId?: number
    }
  ) =>
    this.post<
      ListingDTO<BidderCampaignStat> & { currency: string }
    >`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/stat/`(options)

  getBidderCampaignStatSummary = (
    apiKeyId: number,
    campaignId: number,
    options: {
      currency: string
      from?: ISO8601DateString
      to?: ISO8601DateString
    }
  ) =>
    this
      .post<BidderCampaignStatSummary>`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/stat/summary/`(
      options
    )

  getBidderCampaignAggregateStat = (
    filter: BidderCampaignStatAggregateFilter,
    signal: AbortSignal
  ) =>
    this.post<
      ListingDTO<BidderCampaignStatAggregate> & { currency: string }
    >`/bidder/campaign/${this.currentMall.code}/stat/aggregate/`(filter, { signal })

  getBidderCampaignAggregateStatSummary = (
    filter: BidderCampaignStatAggregateFilter,
    signal: AbortSignal
  ) =>
    this
      .post<BidderCampaignStatAggregateSummary>`/bidder/campaign/${this.currentMall.code}/stat/aggregate/summary/`(
      filter,
      { signal }
    )

  getBidderCampaignBidderStat = (
    apiKeyId: number,
    campaignId: number,
    options: {
      currency: string
      sku?: string
      clusterId?: number
      from?: ISO8601DateTimeString
      to?: ISO8601DateTimeString
    }
  ) =>
    this.post<
      ListingDTO<BidderCampaignSimplifiedBidderStat> & { currency: string }
    >`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/bidder-stat/`(options)

  getFeedBidDistribution = (
    request: BidderCampaignBidDistributionRequest & { currency: string },
    abortSignal?: AbortSignal
  ) =>
    this.post<
      { currency: string; items: BidderCampaignBidDistribution[] }
    >`/bidder/feed/${this.currentMall.code}/feed-positions/`(request, {
      signal: abortSignal,
    })

  getBidderCampaignBidPrediction = (
    apiKeyId: number,
    campaignId: number,
    request: BidderCampaignBidDistributionRequest,
    targetPositions: number[],
    abortSignal?: AbortSignal
  ) =>
    this.post<
      ListingDTO<BidderCampaignBidPrediction>
    >`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/bid-predict/`(
      {
        ...request,
        targetPositions,
      },
      { signal: abortSignal }
    )

  getBidderCampaignHeatmap = (filter: BidderCampaignHeatmapFilter) =>
    this.post<BidderCampaignHeatmap>`/bidder/campaign/${this.currentMall.code}/stat/heat-map/`(
      filter
    )

  getBidderRegions = () => this.get<BusinessRegion[]>`/bidder/region/${this.currentMall.code}/list/`

  getFeedProductCurrentPositions = (
    request: BidderCampaignBidDistributionRequest & { skus: string[] }
  ) =>
    this.post<
      ListingDTO<BidderProductCurrentPosition>
    >`/bidder/feed/${this.currentMall.code}/product-positions/`(request)

  syncBidderCampaignList = () =>
    this.post<BidderSyncResponse>`/bidder/campaign/${this.currentMall.code}/sync-all/`({})

  syncBidderCampaign = (apiKeyId: number, campaignId: number) =>
    this
      .post<BidderSyncResponse>`/bidder/campaign/${this.currentMall.code}/${apiKeyId}/${campaignId}/sync/`(
      {}
    )

  getBidderCampaignBudgetReplenishment = (campaignId: number, currency: string) =>
    this
      .get<BidderCampaignBudgetReplenishment>`/bidder/campaign/${this.currentMall.code}/${campaignId}/budget/replenishment/settings/?currency=${currency}`

  updateBidderCampaignBudgetReplenishment = (
    campaignId: number,
    request: BidderCampaignBudgetReplenishmentUpdate & { currency: string }
  ) =>
    this
      .post<BidderCampaignBudgetReplenishment>`/bidder/campaign/${this.currentMall.code}/${campaignId}/budget/replenishment/settings/update/`(
      request
    )

  getBidderCampaignBudgetReplenishmentLog = (campaignId: number, currency: string) =>
    this.get<
      ListingDTO<BidderCampaignBudgetReplenishmentLog> & { currency: string }
    >`/bidder/campaign/${this.currentMall.code}/${campaignId}/budget/replenishment/logs/?currency=${currency}`

  //
  //
  // BUSINESS SUPPLY RECOMMENDATION METHODS
  //

  getSupplyRecommendation = (request: SupplyRecommendationRequest) =>
    this
      .post<SupplyRecommendationReport>`/mall-analytics/supply/${this.currentMall.code}/recommendation/`(
      request
    )

  getSupplyRecommendationSettings = () =>
    this
      .get<SupplyRecommendationSettings>`/mall-analytics/supply/${this.currentMall.code}/settings/`

  getSupplyRecommendationAvailableSettings = () =>
    this
      .get<SupplyRecommendationAvailableSettings>`/mall-analytics/supply/${this.currentMall.code}/filters/`

  //
  //
  // BUSINESS SUPPLY BOOKING METHODS
  //

  startCreatingSupplyBookingAccount = (apiKeyId: number, phone: string) =>
    this.post`/supply-booking/account/${this.currentMall.code}/${apiKeyId}/start-create/`({ phone })

  sendSupplyBookingAuthCode = (apiKeyId: number, phone: string, authCode: string) =>
    this.post<{
      needSecondFactor: boolean
    }>`/supply-booking/account/${this.currentMall.code}/${apiKeyId}/send-auth-code/`({
      phone,
      authCode,
    })

  sendSupplyBookingSecondFactorAuthCode = (apiKeyId: number, phone: string, authCode: string) =>
    this.post`/supply-booking/account/${this.currentMall.code}/${apiKeyId}/send-second-auth-code/`({
      phone,
      authCode,
    })

  disconnectSupplyBookingAccount = (apiKeyId: number) =>
    this.post`/supply-booking/account/${this.currentMall.code}/${apiKeyId}/drop-session/`({})

  getSupplyBookingOrder = (orderId: number) =>
    this.get<SupplyBookingOrder>`/supply-booking/orders/${this.currentMall.code}/${orderId}/info/`

  getSupplyBookingOrdersList = (apiKeyId?: number) =>
    this.post<{
      items: SupplyBookingOrder[]
      lastSyncedAt: ISO8601DateTimeString
    }>`/supply-booking/orders/${this.currentMall.code}/list/`({
      marketplaceAccountId: apiKeyId ?? null,
    })

  supplyBookingSyncAll = () =>
    this.post<void>`/supply-booking/orders/${this.currentMall.code}/sync-all/`({})

  planSupplyBookingOrder = (
    apiKeyId: number,
    orderId: number,
    request: SupplyBookingOrderPlanRequest
  ) =>
    this.post`/supply-booking/orders/${this.currentMall.code}/${apiKeyId}/${orderId}/plan/`(request)

  cancelSupplyBookingOrder = (apiKeyId: number, orderId: number) =>
    this.post`/supply-booking/orders/${this.currentMall.code}/${apiKeyId}/${orderId}/cancel/`({})

  //
  //
  // BUSINESS REPRICER METHODS
  //

  getRepricerLimits = async (abortSignal?: AbortSignal) => {
    const response = await this.api.get<RepricerLimit[]>('/repricer/limits/', {
      signal: abortSignal,
    })
    return response.data
  }

  getRepricerStoreSettings = () =>
    this.post<RepricerStoreSettings[]>`/repricer-settings/${this.currentMall.code}/list/`({})

  updateRepricerStoreSettings = (apiKeyId: number, request: RepricerStoreSettings) =>
    this.post`/repricer-settings/${this.currentMall.code}/${apiKeyId}/set/`(request)

  addRepricerProducts = (request: RepricerAddRequest) =>
    this.post<RepricerListItem[]>`/repricer/${this.currentMall.code}/add/`(request)

  updateRepricer = (request: RepricerUpdateRequest) =>
    this.post<RepricerListItem>`/repricer/${this.currentMall.code}/update/`(request)

  updateRepricers = (selector: RepricerProductSelector, patch: RepricerConfigPatch) =>
    this.post`/repricer/${this.currentMall.code}/update-many/`({ selector, patch })

  deleteRepricer = (product: RepricerProductKey) =>
    this.post`/repricer/${this.currentMall.code}/delete/`(product)

  deleteRepricers = (selector: RepricerProductSelector) =>
    this.post`/repricer/${this.currentMall.code}/delete-many/`({ selector })

  enableRepricer = (product: RepricerProductKey) =>
    this.post`/repricer/${this.currentMall.code}/enable/`(product)

  enableRepricers = (selector: RepricerProductSelector) =>
    this.post`/repricer/${this.currentMall.code}/enable-many/`({ selector })

  disableRepricer = (product: RepricerProductKey) =>
    this.post`/repricer/${this.currentMall.code}/disable/`(product)

  disableRepricers = (selector: RepricerProductSelector) =>
    this.post`/repricer/${this.currentMall.code}/disable-many/`({ selector })

  disableAllRepricers = (filter: Omit<RepricerListFilter, 'limit' | 'after'>) =>
    this.post<RepricerProductKey[]>`/repricer/${this.currentMall.code}/disable-all/`({ filter })

  getRepricer = (product: RepricerProductKey) =>
    this.post<RepricerListItem>`/repricer/${this.currentMall.code}/get/`(product)

  getRepricerList = async (filter: RepricerListFilter, abortSignal?: AbortSignal) => {
    const { limit, after, ...values } = filter
    const selector = Object.values(values).some(
      (value) => value !== undefined && value !== '' && (!Array.isArray(value) || value.length > 0)
    )
      ? { type: 'filter' as const, filter: values }
      : { type: 'all' as const }
    const data = await this.post<{
      repricers: RepricerListItem[]
      total: number
    }>`/repricer/${this.currentMall.code}/list/`({ selector, limit, after }, {
      signal: abortSignal,
    })
    return { items: data.repricers, total: data.total }
  }

  getRepricerVariants = (selector: RepricerProductSelector, abortSignal?: AbortSignal) =>
    this.post<RepricerVariants>`/repricer/${this.currentMall.code}/settings-variants/`(
      { selector },
      { signal: abortSignal }
    )

  getRepricerTags = () =>
    this.post<string[]>`/repricer/${this.currentMall.code}/tags/list/`({})

  getRepricerTagsWithProducts = async (
    filter: RepricerTagListFilter,
    abortSignal?: AbortSignal
  ) => {
    type TagProduct = Omit<RepricerListItem, 'tags' | 'product'> &
      RepricerListItem['product']
    const data = await this.post<{
      tags: { tag: string; products: TagProduct[] }[]
      total: number
    }>`/repricer/${this.currentMall.code}/tags/list-with-products/`(filter, {
      signal: abortSignal,
    })

    return {
      items: data.tags.map(({ tag, products }): RepricerTagListItem => ({
        tag,
        products: products.map(
          ({ sku, marketplaceAccountId, enabled, config, lastChange, name, url, image, ...rest }) => ({
            ...rest,
            sku,
            marketplaceAccountId,
            enabled,
            tags: [tag],
            config,
            product: { sku, name, url, image, lastChange },
          })
        ),
      })),
      total: data.total,
    }
  }

  addRepricerTag = (selector: RepricerProductSelector, tag: string) =>
    this.post`/repricer/${this.currentMall.code}/tags/add/`({ selector, tag })

  removeRepricerTag = (selector: RepricerProductSelector, tag: string) =>
    this.post`/repricer/${this.currentMall.code}/tags/remove/`({ selector, tag })

  repricerExportRequest = (marketplaceAccountId: number, selector: RepricerProductSelector) => {
    const exportSelector = selector.type === 'filter'
      ? (() => {
          const { marketplaceAccountId: _marketplaceAccountId, ...filter } = selector.filter
          return Object.keys(filter).length > 0
            ? { type: 'filter' as const, filter }
            : { type: 'all' as const }
        })()
      : selector.type === 'products'
        ? { type: 'products' as const, products: selector.products.map(({ sku }) => ({ sku })) }
        : selector
    return {
      href: `/api/export/repricer/${this.currentMall.code}/export/`,
      body: { marketplaceAccountId, selector: exportSelector },
    }
  }

  repricerImportTemplateRequest = (
    marketplaceAccountId: number,
    products: { sku: string; defaultPrice?: number | null }[]
  ) => ({
    href: `/api/export/repricer/${this.currentMall.code}/import-template/`,
    body: { marketplaceAccountId, products },
  })

  importRepricers = (marketplaceAccountId: number, file: File) => {
    const formData = new FormData()
    formData.append('marketplaceAccountId', String(marketplaceAccountId))
    formData.append('file', file)
    return axios.post(`/api/export/repricer/${this.currentMall.code}/import/`, formData)
  }

  getRepricerCharts = (product: RepricerProductKey, request: RepricerChartsRequest) =>
    this.post<RepricerChartData>`/repricer/${this.currentMall.code}/charts/`({
      ...product,
      ...request,
    })

  getRepricerChangelog = (
    product: RepricerProductKey,
    request: RepricerChangelogRequest,
    abortSignal?: AbortSignal
  ) =>
    this.post<RepricerChangelog>`/repricer/${this.currentMall.code}/changelog/`(
      { ...product, ...request },
      { signal: abortSignal }
    )

  calculateRepricerMarginality = (
    products: (RepricerProductKey & RepricerMarginalityCalculateRequest)[]
  ) =>
    this.post<
      RepricerMarginalityPreviewItem[]
    >`/repricer/${this.currentMall.code}/marginality/calculate/`({ products })

  calculateRepricerMarginalityFormula = (products: RepricerProductKey[]) =>
    this.post<
      RepricerMarginalityFormula[]
    >`/repricer/${this.currentMall.code}/marginality/calculate-formula/`({ products })

  getRepricerProductsInfo = (
    request: RepricerGetProductsInfoRequest & { marketplaceAccountId?: number },
    mall: MallCode = this.currentMall.code
  ) =>
    this.post<{
      products: RepricerProductInfo[]
      alreadyExists: RepricerProductInfo[]
    }>`/repricer/products/${mall}/list/`(request)

  getRepricerProductAnalogues = (sku: string) =>
    this.post<{
      total: number
      products: RepricerProductAnalogue[]
    }>`/mall-analytics/dashboard/${this.currentMall.code}/product/analogues/`({ sku })

  getRepricerPromotionsGroupedByPromotions = (request: RepricerPromotionsRequest) =>
    this.post<
      RepricerPromotionWithProducts[]
    >`/repricer/promotions/${this.currentMall.code}/grouped-by-promotions/`(request)

  getRepricerPromotionsGroupedByProducts = (request: RepricerPromotionsRequest) =>
    this.post<
      RepricerProductWithPromotions[]
    >`/repricer/promotions/${this.currentMall.code}/grouped-by-products/`(request)

  uploadRepricerProductsFile = (
    file: File,
    type: 'sellerProducts' | 'competitors',
    marketplaceAccountId?: number
  ) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('productsType', type)
    if (marketplaceAccountId !== undefined) {
      formData.append('marketplaceAccountId', String(marketplaceAccountId))
    }
    return this.api.post<{
      products: RepricerProductInfo[]
      alreadyExists: RepricerProductInfo[]
    }>(
      `/repricer/products/${this.currentMall.code}/from-file/`,
      formData,
      { validateStatus: (status) => status >= 200 && status < 300 }
    )
  }

  getRepricerRegions = () =>
    this.get<BusinessRegion[]>`/repricer/region/${this.currentMall.code}/list/`

  //
  //
  // WB & OZON COMMISSIONS DATA METHODS
  //

  getMarketplaceCommissions = () =>
    this
      .get<MarketplaceCommission>`/mall-analytics/unit-economics/${this.currentMall.code}/commissions/`

  getTariffCoefficients = () =>
    this
      .get<TariffCoefficient>`/mall-analytics/unit-economics/${this.currentMall.code}/tariff-coefficients/`

  //
  //
  // AUTH METHODS
  //

  private authValidateStatus = (status: number) =>
    (status >= 200 && status < 300) || status === 400 || status === 429

  startMessengerAuth = (provider: MessengerAuthProvider, signal: AbortSignal) =>
    this.api.post<MessengerAuthStartResponse | MessengerAuthError>(
      `/auth/messenger/${provider}/start/`,
      undefined,
      {
        signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'x-auth': 'false' },
        timeout: 15000,
        validateStatus: () => true,
      }
    )

  getMessengerAuthStatus = (
    provider: MessengerAuthProvider,
    attemptId: string,
    signal: AbortSignal
  ) =>
    this.api.get<MessengerAuthStatusResponse | MessengerAuthError>(
      `/auth/messenger/${provider}/status/`,
      { params: { attemptId }, signal, timeout: 15000, headers: { 'x-auth': 'false' }, validateStatus: () => true }
    )

  completeMessengerAuth = (
    provider: MessengerAuthProvider,
    attemptId: string,
    csrfToken: string,
    signal: AbortSignal
  ) =>
    this.api.post<MessengerAuthCompleteResponse | MessengerAuthError>(
      `/auth/messenger/${provider}/complete/`,
      { attemptId },
      {
        signal,
        headers: { 'X-CSRF-Token': csrfToken, 'x-auth': 'false' },
        timeout: 15000,
        validateStatus: () => true,
      }
    )

  registerUser = (user: NewUser) =>
    this.post<RegisterResponse>`/register/`(user, {
      validateStatus: (status) => this.authValidateStatus(status),
    })

  registerSendAuthCode = (phone: string, token?: string | null) =>
    this.post<RegisterSendAuthCodeResponse>`/register/send-auth-code/`(
      {
        phone,
        ...(token && { token }),
      },
      {
        validateStatus: (status) => this.authValidateStatus(status),
      }
    )

  logIn = (loginData: LoginData) =>
    this.post<LoginResponse>`/auth/login/`(loginData, {
      validateStatus: (status) => this.authValidateStatus(status),
    })

  logInSubmitAuthCode = (authCode: string) =>
    this.post<LoginSubmitAuthCodeResponse>`/auth/two-factor/`(
      { authCode },
      {
        validateStatus: (status) => this.authValidateStatus(status),
      }
    )

  recoverySendAuthCode = (phone: string) =>
    this.post<RecoverySendAuthCodeResponse>`/recovery/send-reset-code/`(
      { phone },
      {
        validateStatus: (status) => this.authValidateStatus(status),
      }
    )

  recoveryResetPassword = (phone: string, authCode: string) =>
    this.post<RecoveryResetPasswordResponse>`/recovery/reset-password/`(
      { authCode, phone },
      {
        validateStatus: (status) => this.authValidateStatus(status),
      }
    )

  getAuthenticatorsList = () => this.get<WebauthnAuthenticator[]>`/webauthn/authenticators/list/`

  getAuthenticatorAddOptions = () => this.post<WebauthnAddOptions>`/webauthn/add/options/`({})

  addAuthenticator = (authenticator: WebauthnAuthenticatorCreate) =>
    this.post<{ status: 'ok' | 'error' }>`/webauthn/authenticators/add/`(authenticator)

  deleteAuthenticator = (authenticatorId: string) =>
    this.post<{ status: 'ok' | 'error' }>`/webauthn/authenticators/${authenticatorId}/delete/`({})

  getUserApiKeys = () => this.get<UserApiKey[]>`/user-api-key/list/`

  createUserApiKey = (name?: string) => {
    const trimmedName = name?.trim()

    return this.post<CreatedUserApiKey>`/user-api-key/create/`(
      trimmedName ? { name: trimmedName } : {}
    )
  }

  deleteUserApiKey = (id: number) => this.post<[]>`/user-api-key/${id}/delete/`({})

  getLogInWithAuthenticatorOptions = () => this.post<WebauthnLogInOptions>`/webauthn/options/`({})

  logInWithAuthenticator = (request: WebauthnLogInRequest) =>
    this.post<{ status: 'ok' | 'error' }>`/webauthn/result/`(request)

  getPromoCodeSignup = (code: string) =>
    this.get<PromoCode | []>`/register/promo-code/?promoCode=${code}`

  getPromoCodeSubscription = (code: string) =>
    this.get<PromoCode | []>`/subscription/promo-code/?promoCode=${code}`

  applyPromoCodeTrialAfterSignup = (code: string) =>
    this.post<PromoCode | []>`/subscription/promo-code/apply-trial/`({
      promoCode: code,
    })

  applyTrialEmail = (email: string) => this.post<User>`/user/trial-email/`({ email })

  getDefaultTrialDaysSignup = () => this.get<number>`/register/default-trial-days/`

  getDefaultTrialDaysSubscription = () => this.get<number>`/subscription/default-trial-days/`

  testEmail = (email: string) => this.post<'taken' | 'available'>`/register/test-email/`({ email })

  testPhone = (phone: string) => this.post<'taken' | 'available'>`/register/test-phone/`({ phone })

  // Landing methods

  requestDemo = (request: CompanyContactRequest, token?: string | null) =>
    this.post<{ status: 'success' | 'error' | 'CaptchaFailed' }>`/landing/demo/`({
      ...request,
      ...(token && { token }),
    })

  requestInstallment = (request: PersonContactRequest, token?: string | null) =>
    this.post<{ status: 'success' | 'error' | 'CaptchaFailed' }>`/landing/installment/`({
      ...request,
      ...(token && { token }),
    })

  requestConsulting = (request: PersonContactRequest, token?: string | null) =>
    this.post<{ status: 'success' | 'error' | 'CaptchaFailed' }>`/landing/consulting/`({
      ...request,
      ...(token && { token }),
    })

  requestElevenEleven = (request: { phone: string; adCommunicationsConsentReceived?: boolean }) =>
    this.post<{ status: 'success' | 'error' }>`/landing/eleven-eleven/`(request)

  getSellematicsArticles = (page: number, pageSize: number, lang: 'ru' | 'en') =>
    this.get<BLArticleList>`/articles/list/${lang}/?page=${page}&pageSize=${pageSize}`

  getSellematicsArticleBySlug = (slug: string) => this.get<BLArticle>`/articles/detail/${slug}/`

  requestPartnerProgram = (request: PartnerProgramContactRequest, token?: string | null) =>
    this.post<{ status: 'success' | 'error' | 'CaptchaFailed' }>`/landing/partner/`({
      ...request,
      ...(token && { token }),
    })

  requestShopAnalysis = (request: ShopAnalysisRequest) =>
    this.post<{ status: 'success' }>`/landing/shop-analysis/`(request)

  // AI methods

  getAiFeatureTimeout = (mall: string, feature: AiFeatureName, count = 1) =>
    this.post<{ seconds?: number; error?: string | null }>`/ai/${mall}/allow/${feature}/`({ count })

  addAiFeatureUse = (mall: string, feature: AiFeatureName, count = 1) => {
    if (!this.isServerSide) {
      throw new Error('addAiFeatureUse is only available on the server')
    }
    return this.post<{ status: 'ok' | 'error' }>`/ai/${mall}/add/${feature}/`({ count })
  }

  generateGeminiImage = async (options: {
    mall: string
    messages: Array<{
      id: string
      role: 'user' | 'assistant'
      parts: Array<
        | { type: 'text'; text: string; thoughtSignature?: string; thought?: boolean }
        | { type: 'file'; url: string; thoughtSignature?: string; thought?: boolean }
      >
    }>
    imageSize?: string
    aspectRatio?: string | null
    model?: string
    generationMode?: 'single' | 'batch'
  }): Promise<{
    role: 'assistant'
    parts: Array<
      | { type: 'text'; text: string; thoughtSignature?: string; thought?: boolean }
      | { type: 'file'; url: string; thoughtSignature?: string; thought?: boolean }
    >
    refundedCount?: number
  }> => {
    const response = await this.api.post<{
      role: 'assistant'
      parts: Array<
        | { type: 'text'; text: string; thoughtSignature?: string; thought?: boolean }
        | { type: 'file'; url: string; thoughtSignature?: string; thought?: boolean }
      >
      refundedCount?: number
    }>('/generate-gemini-image/', options, {
      validateStatus: (status) => status >= 200 && status < 300,
    })

    return response.data
  }

  generateGeminiVideo = async (options: {
    mall: string
    messages: Array<{
      id: string
      role: 'user' | 'assistant'
      parts: Array<
        { type: 'text'; text: string } | { type: 'file'; url: string; interactionId?: string }
      >
    }>
    aspectRatio?: '16:9' | '9:16'
    resolution?: '720p' | '1080p' | '4K'
    durationSeconds?: number
    minDurationSeconds?: number
  }) => {
    const response = await this.api.post<{
      role: 'assistant'
      parts: Array<
        { type: 'text'; text: string } | { type: 'file'; url: string; interactionId?: string }
      >
      interactionId?: string
      durationSeconds?: number
      refundedCount?: number
    }>('/generate-gemini-video/', options, {
      validateStatus: (status) => status >= 200 && status < 300,
    })

    return response.data
  }

  generateProductDescription = (options: {
    productName: string
    keywords: string[]
    mall: string
    marketplace: string
    language: 'en' | 'ru'
  }) => this.post<{ completion: string; seconds: number }>`/generate-product-description/`(options)

  // SEO-optimization

  getSimilarProductsSearchQueries = (productId: number) =>
    this.get<
      Feed[]
    >`/seo-optimization/${this.currentMall.code}/product/${productId}/search-queries/`

  getSimilarProductIds = (productId: number) =>
    this.get<
      number[]
    >`/seo-optimization/${this.currentMall.code}/product/${productId}/similar-products/`

  getProductsSearchQueries = (productIds: number[]) =>
    this.post<Feed[]>`/seo-optimization/${this.currentMall.code}/product/search-queries/`({
      ids: productIds,
    })

  startSimilarProductsSearchQueriesExport = (productIds: number[]) =>
    this
      .post<StartExportResponse>`/seo-optimization/${this.currentMall.code}/product/search-queries/export/`(
      {
        ids: productIds,
      }
    )

  getSuggestionPositions = (productId: number) =>
    this.get<
      SuggestionPositionsResponse[]
    >`/seo-optimization/${this.currentMall.code}/product/${productId}/suggestion-positions/`

  startSuggestionPositionsExport = (productId: number) =>
    this
      .post<StartExportResponse>`/seo-optimization/${this.currentMall.code}/product/${productId}/suggestion-positions/export/`(
      {}
    )

  trackActionpayActionClient = (action: ActionpayAction, actionId: string, price: number) =>
    this.post`/bc8b7e7eba0850d50c46d497dba51ae0/`({
      action: actionpayGoalIds[action],
      actionId,
      price,
    })

  // dataset labeling

  getDatasetLabelingProducts = () =>
    this.get<number[]>`/season/${this.currentMall.code}/list/?limit=1`

  saveDatasetLabelingProductTags = (productId: number, tagIds: number[]) =>
    this.post<[]>`/season/${this.currentMall.code}/${productId}/save/`({ ids: tagIds })

  // External advertising

  getExternalAdvertisingProductPublicationsList = (
    productId: number,
    filter: ExternalAdvertisingPublicationListFilter
  ) =>
    this.post<
      ListingDTO<ExternalAdvertisingPublication> & { lastSearchedAt: ISO8601DateTimeString }
    >`/external-advertising/publications/${this.currentMall.code}/${productId}/list/`(filter)

  getExternalAdvertisingPublicationCount = (productsIds: number[]) =>
    this.post<
      ExternalAdvertisingPublicationCount[]
    >`/external-advertising/publications/${this.currentMall.code}/counts/`({
      productsIds,
    })

  getExternalAdvertisingSearchList = (filter: ExternalAdvertisingSearchListFilter) =>
    this.post<
      ListingDTO<ExternalAdvertisingSearch>
    >`/external-advertising/search/${this.currentMall.code}/list/`(filter)

  createExternalAdvertisingSearch = (productId: number) =>
    this.post<
      {} | { status: 'AttemptsLimitReached'; seconds: number }
    >`/external-advertising/search/${this.currentMall.code}/${productId}/create/`(
      {},
      {
        validateStatus: (status) => (status >= 200 && status < 300) || status === 400,
      }
    )

  createExternalAdvertisingExtraSearch = (productId: number) =>
    this.post<
      {} | { error: 'NoExtraSearchesAvailable' }
    >`/external-advertising/search/${this.currentMall.code}/${productId}/extra/create/`(
      {},
      {
        validateStatus: (status) => (status >= 200 && status < 300) || status === 400,
      }
    )

  getAlerts = (lang: 'ru' | 'en') => this.get<Alert[]>`/alerts/?lang=${lang}`

  getWebinarBanner = () => this.get<WebinarBanner | null>`/webinar-banner/`

  getBlogArticles = (page: number, lang: 'ru' | 'en') =>
    this.get<BlogArticlePage>`/blog/articles/?page=${page}&lang=${lang}`

  getBlogArticle = (slug: string) =>
    this.get<Article>`/blog/article/?slug=${encodeURIComponent(slug)}`

  getChangelogEntries = (page: number, tags: string[]) =>
    this.get<ListingDTO<Changelog>>`/changelog-entries/?page=${page}&tags=${tags.join(',')}`

  getSuggestions = (filters: SuggestionsFilters) =>
    this.post<StrapiListing<Suggestion>>`/suggestions/list/`(filters)

  processSuggestionWithAI = (description: string) =>
    this.post<{
      title: string
      tag: Suggestion['tag']
    }>`/suggestions/ai-create/`({
      description,
    })

  moderateSuggestionWithAI = (text: string) =>
    this.post<{ isModerated: boolean }>`/suggestions/ai-moderation/`({
      text,
    })

  createSuggestion = (data: CreateSuggestionData) =>
    this.post<Suggestion>`/suggestions/create/`(data)

  updateSuggestion = (id: number, data: UpdateSuggestionData) =>
    this.post<Suggestion>`/suggestions/update/`({ ...data, id })

  deleteSuggestion = (id: number, lang: 'ru' | 'en') =>
    this.post<Suggestion>`/suggestions/delete/`({ id, lang })

  postSuggestionReaction = (id: number, data: UpdateSuggestionReactionData) =>
    this.post<UpdateSuggestionReactionResponse>`/suggestions/react/`({ id, ...data })

  getSuggestionCommentList = (id: number, pagination: { page: number; pageSize: number }) =>
    this.post<StrapiListing<SuggestionComment>>`/suggestions/comment/list/`({ id, pagination })

  createSuggestionComment = (id: number, data: CreateSuggestionCommentData) =>
    this.post<SuggestionComment>`/suggestions/comment/create/`({ id, ...data })

  deleteSuggestionComment = (id: number, commentId: number, authorId: number) =>
    this.post<SuggestionComment>`/suggestions/comment/delete/`({ id, commentId, authorId })

  blockSuggestionComment = (commentId: number) =>
    this.post<SuggestionComment>`/suggestions/comment/block/`({ commentId })

  getLinkedNotifierAccounts = () =>
    this.post<ListingDTO<LinkedNotifierAccount>>`/notifier-bot/accounts/list/`({})

  createNotifierAuthCode = () =>
    this.post<{ code: string; ttl: number }>`/notifier-bot/accounts/create-auth-code/`({})

  unlinkNotifierAccount = (data: { id: string; type: 'tg' | 'max' }) =>
    this.post`/notifier-bot/accounts/unlink/`(data)

  getNotificationSettings = () => this.get<NotificationSettings>`/notifier/settings/get/`

  updateNotificationSettings = (settings: NotificationSettings) =>
    this.post<NotificationSettings>`/notifier/settings/update/`(settings)

  getAvailableAdditionalPacks = () => this.get<AdditionalPacks>`/packs/list/`

  buyAdditionalPack = (pack: AdditionalPackName<AdditionalPackType, number>) =>
    this.get<{ paymentUrl: string }>`/packs/${pack}/buy/`

  updateProductDescription = (request: ProductUpdateDescriptionRequest) =>
    this.post<{}>`/mall-analytics/product/update/${this.currentMall.code}/description/`(request)

  updateProductImages = (request: ProductUpdateImagesRequest) =>
    this.post<{}>`/mall-analytics/product/update/${this.currentMall.code}/images/`(request)

  bootstrapSupportSession = (data: { page?: string | null; pageTitle?: string | null }) =>
    this.post<{
      session: SupportSession
      history: SupportEvent[]
      lastEventId: string | null
    }>`/support/session/`(data)

  getCurrentSupportSession = () =>
    this.get<{
      session: SupportSession | null
      history: SupportEvent[]
      lastEventId: string | null
    }>`/support/session/current/`

  getSupportStatus = () => this.get<{ online: boolean }>`/support/status/`

  markSupportSessionSeen = (data: { sessionId: string; lastVisibleOperatorEventId: string }) =>
    this.post<{
      session: SupportSession
      lastSeenOperatorEventId: string | null
    }>`/support/session/seen/`(data)

  sendSupportMessage = (data: {
    sessionId: string
    text: string
    page?: string | null
    pageTitle?: string | null
    clientMessageId?: string | null
  }) =>
    this.post<{
      session: SupportSession
      lastEventId: string | null
    }>`/support/message/`(data)

  uploadSupportAttachment = (data: { sessionId: string; file: File }) => {
    const formData = new FormData()
    formData.append('sessionId', data.sessionId)
    formData.append('file', data.file)

    return this.post<{ attachment: SupportAttachment }>`/support/uploads/`(formData)
  }

  sendSupportImageMessage = (data: {
    sessionId: string
    text?: string | null
    files: File[]
    page?: string | null
    pageTitle?: string | null
    clientMessageId?: string | null
  }) => {
    const formData = new FormData()
    formData.append('sessionId', data.sessionId)
    if (data.text) formData.append('text', data.text)
    if (data.page) formData.append('page', data.page)
    if (data.pageTitle) formData.append('pageTitle', data.pageTitle)
    if (data.clientMessageId) formData.append('clientMessageId', data.clientMessageId)
    data.files.forEach((file) => formData.append('files', file))

    return this.post<{
      attachments: SupportAttachment[]
      session: SupportSession
      lastEventId: string | null
    }>`/support/image-message/`(formData)
  }

  resetSupportSession = (data: {
    sessionId?: string | null
    page?: string | null
    pageTitle?: string | null
  }) =>
    this.post<{
      session: SupportSession
      history: SupportEvent[]
      lastEventId: string | null
    }>`/support/session/reset/`(data)

  returnSupportSessionToAi = (data: { sessionId: string }) =>
    this.post<{
      session: SupportSession
      lastEventId: string | null
    }>`/support/session/return-to-ai/`(data)

  rateSupportSession = (data: { sessionId: string; score: 1 | -1 }) =>
    this.post<{
      session: SupportSession
      event: SupportEvent
      lastEventId: string | null
    }>`/support/session/rate/`(data)

  rateSupportBotSession = (data: { sessionId: string; score: 1 | -1 }) =>
    this.post<{
      session: SupportSession
      event: SupportEvent
      lastEventId: string | null
    }>`/support/session/rate-bot/`(data)

  commentSupportSessionRating = (data: { sessionId: string; comment: string }) =>
    this.post<{
      session: SupportSession
      event: SupportEvent
      lastEventId: string | null
    }>`/support/session/rate-comment/`(data)

  commentSupportBotSessionRating = (data: { sessionId: string; comment: string }) =>
    this.post<{
      session: SupportSession
      event: SupportEvent
      lastEventId: string | null
    }>`/support/session/rate-bot-comment/`(data)

  listSupportAdminDialogs = (data: {
    page: number
    query: string
    hostType: HostType | 'all'
    handoffFilter: SupportDialogsHandoffFilter
    revenueFilter: SupportDialogsRevenueFilter
    reviewFilter: SupportDialogsReviewFilter
    reviewCommentFilter: SupportDialogsReviewCommentFilter
    userRatingFilter: SupportDialogsUserRatingFilter
    aiModelFilter: SupportDialogsAiModelFilter
    messageDateFrom?: string | null
    messageDateTo?: string | null
    includeSummary?: boolean
  }) => this.post<SupportDialogsListResponse>`/support/admin/dialogs/list/`(data)

  getSupportAdminDialogDetails = (data: { caseId: string }) =>
    this.post<SupportDialogsDetailsResponse>`/support/admin/dialogs/details/`(data)

  returnSupportAdminDialogToAi = (data: { caseId: string }) =>
    this.post<{ selectedDetails: SupportCaseDetails }>`/support/admin/dialogs/return-to-ai/`(data)

  handoffSupportAdminDialogToOperator = (data: { caseId: string }) =>
    this.post<{ selectedDetails: SupportCaseDetails; handoffFailed: boolean }>`/support/admin/dialogs/handoff/`(data)

  reviewSupportAdminDialogBot = (data: {
    caseId: string
    score: NonNullable<SupportCase['botQualityReview']>['score']
  }) =>
    this.post<{ supportCase: SupportCase }>`/support/admin/dialogs/review-bot/`(data)

  commentSupportAdminDialogBotReview = (data: { caseId: string; comment: string }) =>
    this.post<{ supportCase: SupportCase }>`/support/admin/dialogs/review-bot-comment/`(data)

  sendSupportAdminDialogSms = (data: {
    caseId: string
    text: string
    requestId: string
  }) =>
    this.post<{ selectedDetails: SupportCaseDetails; alreadyExists: boolean }>`/support/admin/dialogs/send-sms/`(
      data
    )

  listSupportKnowledgeBase = (data: {
    page: number
    query: string
    status: SupportKnowledgeBaseStatusFilter
    handoff: SupportKnowledgeBaseHandoffFilter
    embedding: SupportKnowledgeBaseEmbeddingFilter
  }) => this.post<SupportKnowledgeBaseListResponse>`/support/admin/knowledge-base/list/`(data)

  getSupportKnowledgeBaseDetails = (data: { kb_id: string }) =>
    this.post<SupportKnowledgeBaseDetailsResponse>`/support/admin/knowledge-base/details/`(data)

  deleteSupportKnowledgeBaseItem = (data: { kb_id: string }) =>
    this.post<SupportKnowledgeBaseDeleteResponse>`/support/admin/knowledge-base/delete/`(data)

  saveSupportKnowledgeBaseItem = (data: SupportKnowledgeBaseSaveRequest) =>
    this.post<SupportKnowledgeBaseSaveResponse>`/support/admin/knowledge-base/save/`(data)

  recalculateSupportKnowledgeBaseEmbedding = (data: { kb_id: string }) =>
    this
      .post<SupportKnowledgeBaseRecalculateResponse>`/support/admin/knowledge-base/recalculate-embedding/`(
      data
    )

  recalculateDirtySupportKnowledgeBaseEmbeddings = () =>
    this
      .post<SupportKnowledgeBaseRecalculateDirtyResponse>`/support/admin/knowledge-base/recalculate-dirty/`(
      {}
    )

  importSupportKnowledgeBase = (data: { text: string }) =>
    this.post<SupportKnowledgeBaseImportResponse>`/support/admin/knowledge-base/import/`(data)
}
